import { ScrollArea as RadixScrollArea } from '@radix-ui/themes';
import { withMappingProps } from '../../utils/radix.js';
export const ScrollArea = withMappingProps(RadixScrollArea);
//# sourceMappingURL=scroll-area.js.map